import React from "react";

const CheckBox = ({
  id,
  label,
  detail,
  divStyle = "items-center justify-center",
  onChecked,
  isChecked,
  type,
}) => {
  let unCheckedClasses =
    "border border-solid w-4 h-4 rounded-sm outline-none ring-0 hover:cursor-pointer ";
  let checkedClasses =
    "border border-solid w-4 h-4 rounded-sm outline-none ring-0 hover:cursor-pointer ";

  if (type === "heading") {
    unCheckedClasses +=
      "border-[#8C8C8C] bg-[#D9D9D9] focus:outline-none focus:ring-[#8C8C8C]";
    checkedClasses +=
      "checked:border-[#D48806] checked:bg-[#FAAD14] checked:shadow-[0px_0px_5px_#F9D587] focus:outline-none focus:ring-[#D48806]";
  } else {
    unCheckedClasses +=
      "border-[#BFBFBF] focus:outline-none focus:ring-[#BFBFBF]";
    checkedClasses +=
      "checked:border-[#FFC53D] checked:bg-[#FFD666] checked:shadow-[0px_0px_5px_#F9D587] focus:outline-none focus:ring-[#FFC53D]";
  }
  return (
    <div class={"flex " + divStyle}>
      <div class="flex items-center h-5 cursor-pointer">
        <input
          id={id}
          aria-describedby={id + "-text"}
          type="checkbox"
          checked={isChecked}
          onChange={(e) => onChecked(e.target.checked)}
          className={isChecked ? checkedClasses : unCheckedClasses}
          style={{ display: "block" }}
        />
      </div>
      {(!!label || !!detail) && (
        <div class="ml-2 text-sm">
          <label for="helper-checkbox" class="font-medium text-gray-900">
            {label}
          </label>
          {!!detail && (
            <p
              id="helper-checkbox-text"
              class="text-xs font-normal text-gray-500"
            >
              {detail}
            </p>
          )}
        </div>
      )}
    </div>
  );
};
export default CheckBox;
